import React, { useEffect, useState } from 'react';

import { 
	SimpleShowLayout, ReferenceField, TextField, 
	EmailField, usePermissions, useGetOne
} from 'react-admin';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { formatPhoneNumber, PhoneField } from './PhoneField';
import { LoadingSpinner } from '../LoadingSpinner';
import { UserRoleByCompanyType } from '../../entities';

import QuickPreview from '../CustomDrawer';


export const formatDriverWithPhone = (record) => (
	`${record.first_name} ${record.last_name} | ${formatPhoneNumber(record.phone)}`
);

export const formatDriverLabel = (record) => (
	`${record.first_name} ${record.last_name}`
);


const DriverPreviewView = ({ classes, ...props }) => (
	<SimpleShowLayout {...props}>
		<TextField source="first_name" className={classes.field} />
		<TextField source="last_name" className={classes.field} />
		<ReferenceField source="truck_id" reference="trucks" link={false} className={classes.field}>
			<TextField source="name" />
		</ReferenceField>
		<EmailField source="email" className={classes.field} />
		<PhoneField source="phone" className={classes.field} addLabel={true} />
	</SimpleShowLayout>
);

const driverStyles = withStyles(theme => ({
	field: {
		'& span': {
			display: 'inline-block',
			maxWidth: '20em'
		}
	}
}));

const DriverPreview = driverStyles(DriverPreviewView);


export const DriverPreviewFetch = ({ orderData, driverData, ...props }) => {
	const driverId = driverData.id
	const { data, loading } = useGetOne(props.resource, driverId);

	if (loading) {
		return <LoadingSpinner />;
	}

	return (
		<DriverPreview {...props} id={driverId} record={data} />
	);
};


const ContentComponent = ({ record, refSource, ...props}) => (
	<DriverPreviewFetch
		{...props}
		driverData={{ id: record[refSource] }}
		orderData={record}
	/>
);

const InjectedComponent = ({ contentProps }) => {
	const { record, refSource, handleNestedResourceData } = contentProps;

	useGetOne("drivers", record[refSource], {
		onSuccess: handleNestedResourceData,
	});

	return null;
};

const TransDriverField = ({ source, refSource, record, prefix, handleNestedResourceData, ...rest }) => {
	const { permissions } = usePermissions();

	if (!permissions || !prefix) return null;

	const is3RdPartyBlock = UserRoleByCompanyType.transporter_all_roles.includes(permissions.role) &&
	record[`${prefix}_3rd_party`] === permissions.company_id;

	if (is3RdPartyBlock) return null;

	if (!record[refSource]) {
		return (
			<Typography component="span" variant="body2">
				{record[source]}
			</Typography>
		);
	}

	const contentProps = {
		record, refSource, handleNestedResourceData,
		basePath: "/drivers",  resource: "drivers",
	};

	return (
		<QuickPreview 
			{...rest}
			contentProps={contentProps}
			ContentComponent={ContentComponent}
			InjectedComponent={handleNestedResourceData && InjectedComponent}
		/>
	);
};

TransDriverField.defaultProps = {
	addLabel: true,
};

export default TransDriverField;